import React from "react";
import { Grid } from "@mui/material";
import SalesAreasWithoutVenues from "./Tables/SalesAreasWithoutVenues";
import VenuesWithOrdersWithoutSubscriptions from "./Tables/VenuesWithOrdersWithoutSubscriptions";

function SubsDashboard(props) {
  return (
    <Grid container spacing={1}>
      <Grid item md={6} xs={12}>
        <SalesAreasWithoutVenues />
      </Grid>
      <Grid item md={6} xs={12}>
        <VenuesWithOrdersWithoutSubscriptions />
      </Grid>
    </Grid>
  );
}

export default SubsDashboard;
